import {jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'

import graphql from 'babel-plugin-relay/macro'
import {memo, useEffect, useRef, useState} from 'react'
import {useFragment} from 'react-relay'


import useClickAway from '~/hooks/useClickAway'
import useScrollIntoView from '~/hooks/useScrollIntoVIew'
import SetTaskHighlightMutation from '~/mutations/SetTaskHighlightMutation'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useTaskChildFocus from '../../../../hooks/useTaskChildFocus'
import DeleteTaskMutation from '../../../../mutations/DeleteTaskMutation'
import UpdateTaskMutation from '../../../../mutations/UpdateTaskMutation'
import {isEqualWhenSerialized} from '../../../../shared/isEqualWhenSerialized'
import OutcomeCard from '../../components/OutcomeCard/OutcomeCard'

const Wrapper = styled('div')({
  outline: 'none'
})













const OutcomeCardContainer = memo((props) => {
  const {
    editor,
    className,
    isDraggingOver,
    task: taskRef,
    area,
    isAgenda,
    isViewerMeetingSection,
    meetingId
  } = props
  const task = useFragment(
    graphql`
      fragment OutcomeCardContainer_task on Task @argumentDefinitions(meetingId: {type: "ID"}) {
        editors {
          userId
        }
        content
        id
        ...OutcomeCard_task @arguments(meetingId: $meetingId)
      }
    `,
    taskRef
  )
  const {id: taskId, content} = task
  const atmosphere = useAtmosphere()
  const ref = useRef(null)
  const [isTaskHovered, setIsTaskHovered] = useState(false)

  const {useTaskChild, isTaskFocused, addTaskChild, removeTaskChild} = useTaskChildFocus(taskId)

  const isHighlighted = isTaskHovered || !!isDraggingOver
  useEffect(() => {
    if (!isViewerMeetingSection || !meetingId) return

    SetTaskHighlightMutation(atmosphere, {
      taskId,
      meetingId,
      isHighlighted
    })
  }, [isHighlighted])

  const handleCardUpdate = () => {
    const isFocused = isTaskFocused()
    if (isFocused) return
    if (editor.isEmpty && !isFocused) {
      DeleteTaskMutation(atmosphere, {taskId})
      return
    }
    const nextContentJSON = editor.getJSON()
    if (isEqualWhenSerialized(JSON.parse(content), nextContentJSON)) return
    const updatedTask = {
      id: taskId,
      content: JSON.stringify(nextContentJSON)
    }
    UpdateTaskMutation(atmosphere, {updatedTask, area}, {})
  }

  useScrollIntoView(ref, editor.isEmpty)
  useClickAway(ref, () => setIsTaskHovered(false))
  return (
    _jsx(Wrapper, {
      tabIndex: -1,
      className: className,
      onMouseEnter: () => setIsTaskHovered(true),
      onMouseLeave: () => setIsTaskHovered(false),
      onMouseOver: () => setIsTaskHovered(true),
      ref: ref,
 children: 
      _jsx(OutcomeCard, {
        area: area,
        editor: editor,
        handleCardUpdate: handleCardUpdate,
        isTaskFocused: isTaskFocused(),
        isTaskHovered: isTaskHovered,
        isAgenda: !!isAgenda,
        isDraggingOver: isDraggingOver,
        task: task,
        useTaskChild: useTaskChild,
        addTaskChild: addTaskChild,
        removeTaskChild: removeTaskChild,}
      )
    })
  )
})

export default OutcomeCardContainer
